module.exports = __webpack_public_path__ + "static/media/about-ru.516c4dc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-ru.svg
// module id = 216
// module chunks = 3